import { http } from '@pendo/http';
const metaGroupsApi = '/api/s/_SID_/category/metagroup';
import { i18n_t as $t } from '@utils/i18n';

const buildMemberPayload = (categoryId) => ({
    items: [{
        itemId: categoryId,
        itemType: 'ItemGroup',
        metaGroupMemberAncestorType: 'guideCategory',
    }],
});

export function fetchMetaGroups ({ items } = {}) {
    const params = items ? '?items=true' : '';

    return http.get(`${metaGroupsApi}${params}`);
}

export function fetchMetaGroup ({ id, items } = {}) {
    const params = items ? '?items=true' : '';

    return http.get(`${metaGroupsApi}/${id}${params}`);
}

export function createMetaGroup (metaGroup) {
    return http.post('/api/s/_SID_/category', {
        type: 'metaGroup',
        ...metaGroup,
    });
}

export function addCategoryToMetaGroup ({ metaGroupId, categoryId }) {
    return http.patch(
        `/api/s/_SID_/category/metaGroup/${metaGroupId}/members/add`,
        buildMemberPayload(categoryId),
    );
}

export function removeCategoryFromMetaGroup ({ metaGroupId, categoryId }) {
    return http.patch(
        `/api/s/_SID_/category/metaGroup/${metaGroupId}/members/remove`,
        buildMemberPayload(categoryId),
    );
}

// BE doesn't support i18n, so we need to handle it on the FE
export function localizeMetaGroups (metaGroups) {
    return metaGroups.map((metaGroup) => {
        let localizedName = metaGroup.name;
        switch (metaGroup.name) {
            case 'General Notification':
                localizedName = $t('metaGroups.General Notification');
                break;
            case 'Education':
                localizedName = $t('metaGroups.Education');
                break;
            case 'Research':
                localizedName = $t('metaGroups.Research');
                break;
            default:
        }

        return {
            ...metaGroup,
            name: localizedName,
        };
    });
}
